import {
    FETCH_RECOMMENDED_PRODUCTS,
    DOWNLOAD_RECOMMENDED_EXCEL
} from "./actions.type";
import {
    RECOMMENDED_FETCH_START,
    NO_RESPONSE_ERROR,
    RECOMMENDED_FETCH_END,
    RECOMMENDED_FILE_DOWNLOADED,
} from "./mutations.type";
import { ParametricSearchService } from "../common/api.service";
import { downloadFile, mimeTypes } from "../common/download.service";

export function getInitialState() {
    return {
        recommendedProducts: {},
        isRecommendedDriverLoading: false,
        isRecommendedDriverSucceeded: false,
        powerLabelRD: "pl1db"
    }
}

const state = getInitialState();

const getters = {
    recommendedProducts(state){
        return state.recommendedProducts
    },
    isRecommendedDriverLoading(state){
        return state.isRecommendedDriverLoading;
    },
    isRecommendedDriverSucceeded(state){
        return state.isRecommendedDriverSucceeded;
    },
    powerLabelRD(state) {
        return state.powerLabelRD;
    }
};

const actions = {
    [FETCH_RECOMMENDED_PRODUCTS]({commit}, params) {
        commit(RECOMMENDED_FETCH_START);
        return ParametricSearchService.recommendedDriverQuery(params)
            .then(({data}) => {
                commit(RECOMMENDED_FETCH_END, data);
            })
            .catch(error => {
                commit(NO_RESPONSE_ERROR);
                throw new Error(error);
            });
    },

    [DOWNLOAD_RECOMMENDED_EXCEL]({commit}, params) {
        return ParametricSearchService.downloadExcel(params)
            .then(function (response) {
                downloadFile(response, mimeTypes.xlsx);
                commit(RECOMMENDED_FILE_DOWNLOADED);
            })
            .catch(error => {
                commit(NO_RESPONSE_ERROR);
                throw new Error(error);
            });
    },
};

const mutations = {
    [RECOMMENDED_FETCH_START](state) {
        state.recommendedProducts = {};
        state.isRecommendedDriverLoading = true;
    },
    [RECOMMENDED_FETCH_END](state, data){
        state.isRecommendedDriverSucceeded = data.success;
        if(state.isRecommendedDriverSucceeded){
            state.isRecommendedDriverLoading = false;
            state.recommendedProducts = data.products;
            state.powerLabelRD = data.powerLabel;
        }
    },
    [NO_RESPONSE_ERROR] (){
        state.isRecommendedDriverSucceeded = false;
        state.isRecommendedDriverLoading = false;
    },
    [RECOMMENDED_FILE_DOWNLOADED] (){
        state.isRecommendedDriverLoading = false;
        state.isRecommendedDriverSucceeded = true;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}